import Icon from "hardcover-ui/components/Icon";
import faXmark from "icons/duotone/xmark.svg";
import classNames from "lib/classNames";

const CloseModalButtonClass = classNames(
  "font-bold whitespace-nowrap px-2 py-1.5 rounded-lg transition-all",
  "text-foreground hover:bg-secondary hover:text-foreground "
);
export default function CloseModalButton({
  onClick,
  className = "",
}: {
  onClick: () => void;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={() => onClick()}
      aria-label="Close search"
      className={`${CloseModalButtonClass} ${className}`}
    >
      <Icon icon={faXmark} size="lg" />
    </button>
  );
}
